import { Component } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackService } from '../../service/snack.service';

@Component({
    selector: 'app-two-factorauth',
    standalone: false,

    templateUrl: './two-factorauth.component.html',
    styleUrl: './two-factorauth.component.scss'
})
export class TwoFactorauthComponent {
    hidespinner: boolean = true;
    verifyForm: FormGroup;
    verifyId: string = ""

    constructor(
        private authService: AuthandregistryService,
        private _fb: FormBuilder,
        private snack: SnackService
    ) {
        this.verifyForm = this._fb.group({
            code: ['', Validators.required],
        });

        // Get the verifyId from the URL split url at the last /
        this.verifyId = window.location.href.split('/').pop() || "";
        if (this.verifyId.indexOf('?') !== -1) {
            this.verifyId = this.verifyId.split('?')[0];
        }

        let code = window.location.search.split('code=')[1];
        if (code?.indexOf('&') > -1) code = code.split('&')[0];

        if (code) {
            this.verifyForm.patchValue({ code: code });
            this.onSubmit();
        }
    }

    async onSubmit() {
        if (this.verifyForm.invalid || typeof this.verifyForm.value.code !== 'string') return;

        this.hidespinner = false;
        await this.authService.verify2fa(this.verifyId, this.verifyForm.value.code);
        this.hidespinner = true;
    }
    async newCode() {
        this.hidespinner = false;
        let usermail = localStorage.getItem('idea_loginemail')
        if (!usermail) {
            this.hidespinner = true;
            this.snack.error({ error: { msg: { "headline": "Missing data", "text": "No E-Mail for Login found. Please go to Login-Page and log in  again." } } })
            return;
        }
        await this.authService.new2faCode(usermail);
        this.hidespinner = true;

    }
}
